import { Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ExportFileService } from 'src/app/shared/services/export-file/export-file.service';
import { ExportFileDto } from 'src/app/shared/models/export-file/export-file-dto';
import { ModalComponent, PaginatorFetcher, PaginatorFilters, TableConfig } from '@michelin/theme';
import { AlertService, AlertType, Alert } from '@michelin/theme';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';
import { formatIsoDateTime } from 'src/app/shared/utils/functions';

@Component({
    selector: 'app-export-files-modal',
    templateUrl: './export-files-modal.component.html',
    styleUrls: ['./export-files-modal.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ExportFilesModalComponent {
  @ViewChild('modalExportFiles') modalExportFiles: ModalComponent;
  @ViewChild('contentModalExportFiles') contentModalExportFiles: TemplateRef<HTMLElement>;

  files: ExportFileDto[] = [];
  loadingList = false;
  generating = false;
  pageIndex = 0;
  pageSize = 20;
  totalElements = 0;
  automakerId: number;

  tableConfig: TableConfig<ExportFileDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      code: { header: 'Data da Exportação', sortable: true, cell: (item) => formatIsoDateTime(item.dateRegister) },
      file: { header: 'Arquivo', sortable: true, cell: (item) => item.filePath.split('/').pop() || '' },
      actions: { cell: 'actionsCell', header: ' ' }
    }
  };

  fetcher: PaginatorFetcher<ExportFileDto> = (filters: PaginatorFilters) => this.exportFileService.search(this.automakerId, filters);

  constructor(private readonly exportFileService: ExportFileService, private readonly alertService: AlertService) {}

  open(automakerId: number): void {
    this.automakerId = automakerId;
    this.modalExportFiles.open({
      id: 'modalExportFiles',
      width: 900,
      title: 'Arquivos de Exportação de Pedidos',
      content: this.contentModalExportFiles
    });
  }

  download(file: ExportFileDto): void {
    this.exportFileService.download(file.id).subscribe({
      next: ({ blob, filename }) => {
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename || this.buildDefaultFilename(file);
        link.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        if (err.status === 404) {
          this.showError('Arquivo não encontrado.');
        } else {
          this.showError('Erro ao realizar download do arquivo.');
        }
      }
    });
  }

  buildDefaultFilename(file: ExportFileDto): string {
    const datePart = file.dateRegister?.replace(/[:T]/g, '_').split('.')[0];
    const fileExtension = file.filePath?.split('.').pop();
    return `export_pedidos_${file.automakerId}_${datePart}.${fileExtension}`;
  }

  generateNewFile(): void {
    this.loadingList = true;
    this.exportFileService
      .generate(this.automakerId)
      .subscribe({
        next: () =>
          this.alertService.showAlert({
            type: AlertType.success,
            content: 'Arquivo de exportação gerado com sucesso. Verifique a lista para download.'
          } as Alert),
        error: (e) => {
          this.alertService.showAlert({
            type: AlertType.critical,
            content: e.error?.message || 'Erro ao gerar o arquivo de exportação.'
          } as Alert);
        }
      })
      .add(() => {
        this.loadingList = false;
      });
  }

  showAlert(type: AlertType, content: string) {
    this.alertService.showAlert({ type, content } as Alert);
  }

  showError(content: string) {
    this.alertService.showAlert({ type: AlertType.critical, content } as Alert);
  }
}
